/// <amd-module name="Feed/Core/Redux/Navigation/NavigationContracts" />
export interface IFeedNavigationOwnState {
    navigation: IFeedNavigationState;
}

export interface IFeedNavigationState {
    hubState: IHubState;
}

/**
 * The state of the hub from all parameters in the URL.
 */
export interface IHubState {
    action: string; // i.e. _a value from uri
    feed?: string;
    package?: string;
    version?: string;
    upstreamSource?: string;
    protocolType?: string;
    preferRelease?: string; // used when version isn't specified
    view?: string; // legacy - used by VssHubViewState
}

export type IFeedNavigationAwareState = IFeedNavigationOwnState;
